import ReturnFlightDetails from "./ReturnFlightDetails";
import "./Return.css";
import { useDispatch, useSelector } from "react-redux";
import { setCalenderFare, setFilterData, setSearchFlights } from "../../redux/global/global.action";
import moment from "moment";

const ReturnFilter = () => {
  const dispatch = useDispatch();
  const flight_data = useSelector((state) => state.global.flights_list);
  const calender_fare = useSelector((state) => state.global.calender_fare);
  const search_data = useSelector((state) => state.global.search_data);
  const filter_data = useSelector((state) => state.global.search_filters);


  // dispatch(
  //   setFilterData({
  //     ...flight_data,
  //     Results: [...myArrayFiltered, ...myArrayFiltered2],
  //     Results2: [...myArrayFiltered2],
  //   })
  // );
  var selectedairlineArr = [];

  const handleChange = (e) => {
    // alert(e.target.name)

    // debugger;
    var filter_result = filter_data;
    filter_result = {
      ...flight_data
    }
    var flt_arr = filter_result.Results;

    if (e.target.name === "AirlineCode") {

      const air_code = e.target.value.trim();

      if (e.target.checked) {
        selectedairlineArr.push(air_code);
      } else {
        const index = selectedairlineArr.indexOf(air_code);
        if (index > -1) {
          selectedairlineArr.splice(index, 1);
        }
      }

      if(flight_data.status && flight_data.Results.length){
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
            return selectedairlineArr.includes(el.AirlineCode)
          });
          
        }
        filter_result.Results = flt_arr

      
      }

      
      // debugger

      // flight_data.Results.filter((el) => {

      //   if (e.target.checked) {
      //     selectedairlineArr.push(air_code);
      //   } else {
      //     const index = selectedairlineArr.indexOf(air_code);
      //     if (index > -1) {
      //       selectedairlineArr.splice(index, 1);
      //     }
      //   }

      // }
      
      // // el.Segments[0].length == 1
      // );

    }
    if (e.target.name === "flight_reach") {
      const flight_reach = e.target.value.trim();
      if (flight_reach == "direct") {
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
            return   (el) => el.Segments[0].length == 1
          });
          
        }
        filter_result.Results = flt_arr
      }else if(flight_reach == "one_stop") {
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
            return   (el) => el.Segments[0].length == 2
          });
          
        }
        filter_result.Results = flt_arr
      }else if(flight_reach == "two_more") {
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
            return   (el) => el.Segments[0].length >= 2
          });
          
        }
        filter_result.Results = flt_arr
      }
    }

    if (e.target.name === "refund_type") {
      const refund_type = e.target.value.trim();
      if (e.target.checked) {


        if (refund_type == "refund") {

          for (let i = 0; i < flt_arr.length; i++) {
            let element = flt_arr[i];
            flt_arr[i] = element.filter((el) =>{
              return  el.IsRefundable === true
            });
            
          }
          filter_result.Results = flt_arr
         
        } else if (refund_type == "non_refund") {
          for (let i = 0; i < flt_arr.length; i++) {
            let element = flt_arr[i];
            flt_arr[i] = element.filter((el) =>{
              return  el.IsRefundable === false
            });
            
          }
          filter_result.Results = flt_arr
        }
      } 
    }

    if (e.target.name === "flight_type") {
      const flight_type = e.target.value.trim();
      if (e.target.checked) {


        if (flight_type == "lcc") {

          for (let i = 0; i < flt_arr.length; i++) {
            let element = flt_arr[i];
            flt_arr[i] = element.filter((el) =>{
              return  el.IsLCC === true
            });
            
          }
          filter_result.Results = flt_arr
         
        } else if (flight_type == "non_lcc") {
          for (let i = 0; i < flt_arr.length; i++) {
            let element = flt_arr[i];
            flt_arr[i] = element.filter((el) =>{
              return  el.IsLCC === false
            });
            
          }
          filter_result.Results = flt_arr
        }
      } 
    }

    if (e.target.name === "flight_time") {
      const flight_time = e.target.value.trim();
      if(flight_time==='morning'){
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
              let timemoment = moment(moment(el.Segments[0][0].Origin.DepTime)).format("HH");
              if (timemoment >= 3 && timemoment < 12){
                return true
              }
              return false
          });
          
        }
        filter_result.Results = flt_arr
      }else if(flight_time==='afternoon'){
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
              let timemoment = moment(moment(el.Segments[0][0].Origin.DepTime)).format("HH");
              if (timemoment >= 12 && timemoment < 15){
                return true
              }
              return false
          });
          
        }
        filter_result.Results = flt_arr
      }else if(flight_time==='evening'){
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
              let timemoment = moment(moment(el.Segments[0][0].Origin.DepTime)).format("HH");
              if (timemoment >= 15 && timemoment < 20){
                return true
              }
              return false
          });
          
        }
        filter_result.Results = flt_arr
      }else if(flight_time==='night'){
        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
              let timemoment = moment(moment(el.Segments[0][0].Origin.DepTime)).format("HH");
              if (timemoment >= 20 && timemoment < 3){
                return true
              }
              return false
          });
          
        }
        filter_result.Results = flt_arr
      }
      // var currentHour = moment().format("HH");
      // if (currentHour >= 3 && currentHour < 12){
      //     return "Good Morning";
      // } else if (currentHour >= 12 && currentHour < 15){
      //     return "Good Afternoon";
      // }   else if (currentHour >= 15 && currentHour < 20){
      //     return "Good Evening";
      // } else if (currentHour >= 20 && currentHour < 3){
      //     return "Good Night";
      // } else {
      //     return "Hello"
      // }


    }



    if (e.target.name === "city_key") {
      const city_key = e.target.value.trim();
      if (e.target.checked) {

        for (let i = 0; i < flt_arr.length; i++) {
          let element = flt_arr[i];
          flt_arr[i] = element.filter((el) =>{
            var conditioncheck = false
            // return  el.IsLCC === true
            for (let indd = 0; indd < el.Segments.length; indd++) {
              const element2 = el.Segments[indd];
              // console.log(element2);

              // debugger;
              for (let j = 0; j < element2.length; j++) {
                let element3 = element2[j];
                conditioncheck= element3.Origin.Airport.AirportCode === city_key 
                if(conditioncheck){
                  return true;
                }
                
              }
              

            }
            return false
          });
          
        }
        filter_result.Results = flt_arr


        
      } 
    }

    dispatch(setFilterData({
      ...filter_result
    }))
    var get_calender_fare =  localStorage.getItem('SET_CALENDER_FARE')
    var get_search_flight = localStorage.getItem('SET_SEARCH_FLIGHTS')
    if(get_calender_fare){
      get_calender_fare  = JSON.parse(get_calender_fare)
      dispatch(setCalenderFare(get_calender_fare))
    }

    if(get_search_flight){
      get_search_flight = JSON.parse(get_search_flight)
      dispatch(setSearchFlights(get_search_flight))
    }
    /*
    if (e.target.name === "AirlineCode") {
      const air_code = e.target.value.trim();
      if (e.target.checked) {
        selectedairlineArr.push(air_code);
      } else {
        const index = selectedairlineArr.indexOf(air_code);
        if (index > -1) {
          selectedairlineArr.splice(index, 1);
        }
      }
      if (flight_data.status) {
        if (selectedairlineArr.length) {
          const myArrayFiltered = flight_data.Results[0].filter((el) =>
            selectedairlineArr.includes(el.AirlineCode)
          );
          var myArrayFiltered2 = [];
          if (search_data.journeyType == 2) {
            myArrayFiltered2 = flight_data.Results[1].filter((el) =>
              selectedairlineArr.includes(el.AirlineCode)
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...myArrayFiltered, ...myArrayFiltered2],
              Results2: [...myArrayFiltered2],
            })
          );
        } else {
          dispatch(
            setFilterData({
              ...flight_data,
              status: false,
              Results: [],
              Results2: [],
            })
          );
        }
      } else {
        dispatch(
          setFilterData({
            ...flight_data,
            status: false,
            Results: [],
            Results2: [],
          })
        );
      }
    }

    if (e.target.name === "flight_stop") {
      const air_stop = e.target.value.trim();
      if (e.target.checked) {
        selectedFlightStop.push(air_stop);
        if (air_stop == "non_stop") {
          var non_stop_list = flight_data.Results[0].filter(
            (el) => el.Segments[0].length == 1
          );
          var non_stop_list2 = [];
          if (search_data.journeyType == 2) {
            non_stop_list2 = flight_data.Results[1].filter(
              (el) => el.Segments[0].length == 1
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...non_stop_list, ...non_stop_list2],
              Results2: [...non_stop_list2],
            })
          );
        } else if (air_stop == "one_stop") {
          var non_stop_list1 = flight_data.Results[0].filter(
            (el) => el.Segments[0].length == 2
          );
          var non_stop_list12 = [];
          if (search_data.journeyType == 2) {
            non_stop_list12 = flight_data.Results[1].filter(
              (el) => el.Segments[0].length == 2
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...non_stop_list1, ...non_stop_list12],
              Results2: [...non_stop_list12],
            })
          );
        }
      } else {
        // const index = selectedFlightStop.indexOf(air_stop);
        // if (index > -1) {
        //     selectedFlightStop.splice(index, 1);
        // }
      }
      // const myArrayFiltered2 = flight_data.Results[0].filter(el => selectedairlineArr.includes(el.AirlineCode))
    }

    // IsRefundable

    if (e.target.name === "flight_type") {
      const air_type = e.target.value.trim();
      if (e.target.checked) {
        if (air_type == "gds") {
          var gds_list = flight_data.Results[0].filter(
            (el) => el.IsLCC === false
          );
          var gds_list2 = [];
          if (search_data.journeyType == 2) {
            gds_list2 = flight_data.Results[1].filter(
              (el) => el.IsLCC === false
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...gds_list, ...gds_list2],
              Results2: [...gds_list2],
            })
          );
        } else if (air_type == "non_gds") {
          var gds_list = flight_data.Results[0].filter((el) => el.IsLCC);
          var gds_list2 = [];
          if (search_data.journeyType == 2) {
            gds_list2 = flight_data.Results[1].filter((el) => el.IsLCC);
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...gds_list, ...gds_list2],
              Results2: [...gds_list2],
            })
          );
        }
      } else {
      }
    }

    if (e.target.name === "refund_type") {
      const refund_type = e.target.value.trim();
      if (e.target.checked) {
        if (refund_type == "refund") {
          var refund_list = flight_data.Results[0].filter(
            (el) => el.IsRefundable === true
          );
          var refund_list2 = [];
          if (search_data.journeyType == 2) {
            refund_list2 = flight_data.Results[1].filter(
              (el) => el.IsRefundable === true
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...refund_list, ...refund_list2],
              Results2: [...refund_list2],
            })
          );
        } else if (refund_type == "non_refund") {
          var refund_list1 = flight_data.Results[0].filter(
            (el) => el.IsRefundable === false
          );
          var refund_list12 = [];
          if (search_data.journeyType == 2) {
            refund_list12 = flight_data.Results[1].filter(
              (el) => el.IsRefundable === false
            );
          }
          dispatch(
            setFilterData({
              ...flight_data,
              Results: [...refund_list1, ...refund_list12],
              Results2: [...refund_list12],
            })
          );
        }
      } else {
      }
    }
    */
  };

  var airlines_arr = []
  var city_airline_arr = [];
  return (
    <>
      <div className="">
        <div className="row">
          <div class="col-lg-3">
            <div class="card" style={{ width: "20rem" }}>
              <div class="card-body">
                <div class="row" style={{ backgroundColor: "#00FFFF" }}>
                  <div class="col-lg-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                    </svg>
                  </div>
                  <div class="col-lg-3">
                    <strong>Filters</strong>
                  </div>
                  <div class="col-lg-7">
                    <button type="button" class="btn btn-link">
                      Clear all filters
                    </button>
                  </div>
                </div>

                {/* <div class="row">
                  <div class="row row-cols-auto">
                    <div class="col">
                      {" "}
                      <button type="button" class="btn btn-primary">
                        Outbound
                      </button>
                    </div>
                    <div class="col">
                      {" "}
                      <button type="button" class="btn btn-light">
                        Inbound
                      </button>
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-lg-12 col-sm-9 col-9">
                    <h5
                      className="filterMargin"
                      style={{ backgroundColor: "#7FFFD4" }}
                    >
                      Outbound Flight Times:
                    </h5>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flight_time"
                        value="morning"
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />

                      <label class="form-check-label" for="flexCheckDefault">
                        Morning (04:00- 11:00)
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flight_time"
                        value="afternoon"
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        Afternoon (11:00-16:00)
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flight_time"
                        value="evening"
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        Evening (16:00-21:00)
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flight_time"
                        value="night"
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        Night (21:00-04:00am)
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-3"></div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <h4
                      className="filterMargin"
                      style={{ backgroundColor: "#7FFFD4" }}
                    >
                      Stops
                    </h4>

                    <div class="row">
                      <div class="col-lg-3">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flight_reach"
                            value="direct"
                            onChange={handleChange}
                            id="flexCheckDefault"
                          />
                          <label
                            class="form-check-label"
                            for="flexCheckDefault"
                          >
                            Direct
                          </label>
                        </div>
                      </div>
                      <div class="col-lg-2">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flight_reach"
                            value="one_stop"
                            onChange={handleChange}
                            id="flexCheckDefault"
                          />
                          <label
                            class="form-check-label"
                            for="flexCheckDefault"
                          >
                            1
                          </label>
                        </div>
                      </div>
                      <div class="col-lg-5">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flight_reach"
                            value="two_more"
                            onChange={handleChange}
                            id="flexCheckDefault"
                          />
                          <label
                            class="form-check-label"
                            for="flexCheckDefault"
                          >
                            2 & more
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h4
                    className="filterMargin"
                    style={{ backgroundColor: "#7FFFD4" }}
                  >
                    AirLines:
                    <button
                      type="button"
                      class="btn btn-link"
                      style={{ fontSize: "15px" }}
                    >
                      Select
                    </button>
                    <span>/</span>
                    <button
                      type="button"
                      class="btn btn-link"
                      style={{ fontSize: "15px" }}
                    >
                      Unselect All
                    </button>
                  </h4>
                  <div className="row">
                    <div className="col-lg-9 col-sm-9 col-9">
                    {flight_data.status &&
                      flight_data.hasOwnProperty("Results") &&
                      flight_data.Results &&
                      flight_data.Results.length > 0 ?
                      flight_data.Results.map((rs)=>{
                        return rs.map((results) => {
                          if (!airlines_arr.includes(results.AirlineCode)) {
                            airlines_arr.push(results.AirlineCode);
                            return (
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  onChange={handleChange}
                                  name="AirlineCode"
                                  value={results.AirlineCode}
                                  id={results.AirlineCode}
                                  // id="flexCheckDefault"
                                />
                                <label class="form-check-label" >
                                {results.Segments[0][0].Airline.AirlineName} ({results.AirlineCode})
                                </label>
                              </div>
                            )
                          }
                        })
                      })

                      : ""
                    }
                     
                     
                    </div>
                    <div className="col-lg-3 col-sm-3 col-3"></div>
                  </div>
                </div>
                <div>
                  <h4
                    className="filterMargin"
                    style={{ backgroundColor: "#7FFFD4" }}
                  >
                    Layover:
                    <button
                      type="button"
                      class="btn btn-link"
                      style={{ fontSize: "15px" }}
                    >
                      Select
                    </button>
                    <span>/</span>
                    <button
                      type="button"
                      class="btn btn-link"
                      style={{ fontSize: "15px" }}
                    >
                      Unselect All
                    </button>
                  </h4>
                  <div className="row">
                    <div className="col-lg-9 col-sm-9 col-9">
                    {flight_data.status &&
                      flight_data.hasOwnProperty("Results") &&
                      flight_data.Results &&
                      flight_data.Results.length > 0 ?
                      flight_data.Results.map((flights)=>{
                        return flights.map((flight)=>{
                          return flight.Segments.map(rss=>{
                            return rss.map((rs)=>{
                              if (!city_airline_arr.includes(rs.Origin.Airport.AirportCode)) {
                                city_airline_arr.push(rs.Origin.Airport.AirportCode);

                                return (
                                  <div class="form-check">
                                    <input
                                      class="form-check-input"
                                      onChange={handleChange}
                                      type="radio"
                                      name="city_key"
                                      value={rs.Origin.Airport.AirportCode}
                                    />
                                    <label class="form-check-label" for="flexCheckDefault">
                                      {rs.Origin.Airport.CityName} ({rs.Origin.Airport.AirportCode})
                                    </label>
                                  </div>
                                )

                              }

                              if (!city_airline_arr.includes(rs.Destination.Airport.AirportCode)) {
                                city_airline_arr.push(rs.Destination.Airport.AirportCode);

                                return (
                                  <div class="form-check">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      name="city_key"
                                      onChange={handleChange}
                                      value={rs.Origin.Airport.AirportCode}
                                    />
                                    <label class="form-check-label" for="flexCheckDefault">
                                      {rs.Destination.Airport.CityName} ({rs.Destination.Airport.AirportCode})
                                    </label>
                                  </div>
                                )

                              }

                             

                            })
                          })

                        })
                      })
                      :
                      <></>
                    }
                      
                      {/* <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Chennai (MAA)
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Indore (IDR)
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Mumbai(BOM)
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Delhi (DEL)
                        </label>
                      </div> */}
                    </div>
                    <div className="col-lg-3 col-sm-3 col-3"></div>
                  </div>
                </div>
                {/* <div>
                  <h4
                    className="filterMargin"
                    style={{ backgroundColor: "#7FFFD4" }}
                  >
                    Destination:
                  </h4>
                  <div className="row">
                    <div className="col-lg-9 col-sm-9 col-9">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Dabolim (GOI)
                        </label>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div>
                  <h4
                    className="filterMargin"
                    style={{ backgroundColor: "#7FFFD4" }}
                  >
                    Fare Type:
                  </h4>
                  <div className="row">
                    <div className="col-lg-9 col-sm-9 col-9">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          onChange={handleChange}
                          name="refund_type"
                          value="refund"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Refundable
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          onChange={handleChange}
                          name="refund_type"
                          value="non_refund"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Non-Refundable
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h4
                    className="filterMargin"
                    style={{ backgroundColor: "#7FFFD4" }}
                  >
                    Flight Type
                  </h4>
                  <div className="row">
                    <div className="col-lg-10 col-sm-9 col-9">
                    <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="flight_type"
                          onChange={handleChange}
                          value="lcc"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          LCC
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="flight_type"
                          onChange={handleChange}
                          value="non_lcc"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          GDS
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ReturnFlightDetails />
        </div>
      </div>
    </>
  );
};
export default ReturnFilter;
